import { createContext } from 'react'

const BookUsedContext	= createContext(null)

export default BookUsedContext